<template>
  <el-select
    v-model="selected"
    :trigger-on-focus="false"
    :multiple="multiple"
    :collapse-tags="multiple"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <el-option
      v-for="(item, index) in modelList"
      :key="index"
      :label="item.label"
      :value="item.value"
    >
    </el-option>
  </el-select>
</template>
<script>
/**
 * 下拉组件（枚举值）
 * author: 苏金铃
 */
import { getConfigData } from '@/config/bjIndex.js';

export default {
  name: 'BjSelect',
  model: {
    prop: 'data',
    event: 'onDataChange'
  },
  props: {
    data: {
      type: [String, Number, Array, Object],
      default: () => ''
    },
    // 枚举值类型（必填项）
    type: {
      type: String,
      default: () => ''
    },
    // 是否多选
    multiple: {
      type: Boolean,
      default: () => false
    },
    // 是否添加全部
    hasAll: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      selected: ''
    };
  },
  computed: {
    modelList() {
      const data = getConfigData(this.type);
      console.log('====',data)
      return this.hasAll ? [{ value: '', label: '全部' }, ...data] : data;
    }
  },
  watch: {
    selected: {
      handler(selected) { 
        this.$emit('onDataChange', selected);
      }
    },
    data: {
      immediate: true,
      handler(data) {
        this.selected = data;
      }
    }
  },
  created() {

  },
  methods: {

  }
};
</script>
